import { HttpInterceptorFn } from "@angular/common/http";
import { Preferences } from "@capacitor/preferences";
import { PARENT_ACCESS_TOKEN_KEY } from "@malirang/common";
import { catchError, from, mergeMap, throwError } from "rxjs";

export const HttpInterceptor: HttpInterceptorFn = (req, next) => {
    return from(
        (async () => {
            const storage = await Preferences?.get({
                key: PARENT_ACCESS_TOKEN_KEY,
            });
            const accessToken = storage?.value;

            return req.clone({
                setHeaders: {
                    Authorization: accessToken ? `Bearer ${accessToken}` : "",
                },
            });
        })(),
    ).pipe(
        mergeMap((updatedRequest) => next(updatedRequest)),
        catchError((e) => {
            return throwError(() => e.error);
        }),
    );
};
